function broadcast(componentName, eventName, params) {
    this.$children.forEach(child => {
        let name = child.$options.componentName;
        /* eslint-disable */
        if (name === componentName) {
            child.$emit.apply(child, [eventName].concat(params));
        } else {
            broadcast.apply(child, [componentName, eventName].concat([params]));
        }
    });
}

// dispatch方法拷贝自element-ui的方法，作用是对父组件树上的某一个组件发消息，
// 需要对父组件设置componentName属性

export default {
    methods: {
        /**
         * dispatch方法
         * 对对父组件树上的某一个组件发消息
         * 需要对目标父组件设置componentName属性
         * @param componentName 目标组件的componentName 属性值
         * @param eventName 消息名
         * @param params 参数
         */
        dispatch(componentName, eventName, params) {
            let parent = this.$parent || this.$root;
            let name = parent.$options.componentName;

            while (parent && (!name || name !== componentName)) {
                parent = parent.$parent;

                if (parent) {
                    name = parent.$options.componentName;
                }
            }
            if (parent) {
                parent.$emit.apply(parent, [eventName].concat(params));
            }
        },
        /**
         * broadcast方法
         * 对对某一些子组件发消息
         * 需要对目标组件设置componentName属性
         * @param componentName 目标组件的componentName 属性值
         * @param eventName 消息名
         * @param params 参数
         */
        broadcast(componentName, eventName, params) {
            broadcast.call(this, componentName, eventName, params);
        }
    }
};
